import { useEffect, useState } from 'react'

export const useOnlineStatus = (): boolean => {
	const [online, setOnline] = useState(() => (typeof navigator === 'undefined' ? true : navigator.onLine !== false))

	useEffect(() => {
		const goOnline = () => setOnline(true)
		const goOffline = () => setOnline(false)

		window.addEventListener('online', goOnline)
		window.addEventListener('offline', goOffline)
		// A tab restored from bfcache can have missed both events.
		setOnline(navigator.onLine !== false)

		return () => {
			window.removeEventListener('online', goOnline)
			window.removeEventListener('offline', goOffline)
		}
	}, [])

	return online
}
